import React from "react";
import { Listbox } from "@headlessui/react";
import { ChevronUpDownIcon, CheckIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";

import { Fragment } from "react";
import { Transition } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function getStaticYears() {
  let currentDate = new Date();
  let currentYear = currentDate.getFullYear();

  return [currentYear-1, currentYear, currentYear+1];
}

const YearListbox = ({ state, send, disabled = false }) => {
  const years = state.context?.advancedSearchOptions?.period || getStaticYears();
  const currentYear = state.context.year; // Access the current year from state.context
  const { t } = useTranslation();
  
  const handleChange = (year) => {
    send({ type: "YEAR_SELECTED", data: year }); // Example action to set the year
  };

  return (
    <Listbox value={currentYear} onChange={handleChange}>
      {({ open }) => (
        <>
          <Listbox.Button className="relative w-28  cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-sm leading-6 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 disabled:text-gray-300">
            <span
              className={classNames(
                "block truncate ",
                disabled
                  ? "text-gray-300"
                  : !currentYear
                  ? "text-gray-500"
                  : currentYear
                  ? "text-gray-900"
                  : "",
              )}
            >
              {currentYear}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronUpDownIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </span>
            <Listbox.SelectedOption
              placeholder={t("shared.searchWidget.options.period.year")}
            />
          </Listbox.Button>
          <Transition
            show={open}
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-[var(--button-width)]  overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {years.map((year, yearIdx) => (
                <Listbox.Option
                  key={yearIdx}
                  className={({ active }) =>
                    classNames(
                      active ? "bg-indigo-600 text-white" : "text-gray-900",
                      "relative cursor-default select-none py-2 pl-3 pr-9",
                    )
                  }
                  value={year}
                >
                  {({ selected, active }) => (
                    <>
                      <span
                        className={`block truncate ${
                          selected ? "font-medium" : "font-normal"
                        }`}
                      >
                        {year}
                      </span>
                      {selected ? (
                        <span
                          className={classNames(
                            active ? "text-white" : "text-indigo-600",
                            "absolute inset-y-0 right-0 flex items-center pr-4",
                          )}
                        >
                          <CheckIcon className="h-5 w-5" aria-hidden="true" />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </>
      )}
    </Listbox>
  );
};

export default YearListbox;
